export default "__VITE_ASSET__BYom6OYi__"